import { makeAutoObservable } from "mobx";

export class SettingsStore {
  private _persistAnyActions: boolean = true;

  constructor() {
    makeAutoObservable(this);
  }

  public setPersistAnyActions = (persist: boolean) => {
    this._persistAnyActions = persist;
  };

  public get persistAnyActions(): boolean {
    return this._persistAnyActions;
  }
}
